var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { action, makeAutoObservable, observable } from "mobx";
import { ColumnView, getApplicationConfig, showMarket } from "../constants/utilities";
var HomePageStore = /** @class */ (function () {
    function HomePageStore() {
        Object.defineProperty(this, "apiLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "filterConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                columnView: getApplicationConfig().applicationId === 2 ? ColumnView.Rating_Profile_financial : ColumnView.marketStatus,
                show: showMarket.Favorite,
                advanceSearch: null,
                quickSearch: "",
            }
        });
        makeAutoObservable(this, {
            apiLoading: observable,
            filterConfig: observable,
            setFilterConfig: action,
            setAPiLoading: action,
        });
    }
    Object.defineProperty(HomePageStore.prototype, "setFilterConfig", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (config) {
            this.filterConfig = __assign(__assign({}, this.filterConfig), config);
        }
    });
    Object.defineProperty(HomePageStore.prototype, "setAPiLoading", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (loading) {
            this.apiLoading = loading;
        }
    });
    return HomePageStore;
}());
;
export default HomePageStore;
